// extracted by mini-css-extract-plugin
export default {"title":"Menubar_title__2WWlK","container":"Menubar_container__eJ5jC","containerSelected":"Menubar_containerSelected__nyh2O","icon":"Menubar_icon__sd-9Q","menu":"Menubar_menu__xJF+4"};